module.exports = __webpack_public_path__ + "img/94f6e6be-004d-4b3a-8b0e-f07609dc1726.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/94f6e6be-004d-4b3a-8b0e-f07609dc1726.svg
// module id = 177
// module chunks = 245 246